import { BASE_AXIOS } from "../config";

export const apiAddQuestionToDeck = async data => {
    let form = new FormData();
    form.append("mcid", data.mcid);
    form.append("key", data.key);
    form.append("deckID", data.deckID);
    form.append("questionID", data.questionID); 

    /*
        mcid: props.auth_feedback.mcid,
        key: props.auth_feedback.key,
        deckID: props.deckID,
        questionID: name,
        isActiveQuestion: (event.target.checked ? 1 : 0)
    */

    if (typeof data.isActiveQuestion !== 'undefined') {
        form.append("isActiveQuestion", data.isActiveQuestion);
    }

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "addQuestionToDeck"
            },
            data: form
        });

        return response.data;
    } catch (error) {
        throw error;
    }
};
